import React from 'react';

const CTA = () => {
  return (
    <div id="cta" className="about section py-10">
      <div className="container mx-auto">
        <div className="flex flex-wrap" style={{ paddingTop: '40px', paddingBottom: '90px' }}>
          <div className="w-full">
            <div className="wow fadeInLeft" data-wow-duration="2s" data-wow-delay="0s">
              <p className="text-center"><span className="emphasize-text-solution">Stop wasting time.</span></p>
            </div>
            <div className="wow fadeInRight" data-wow-duration="2s" data-wow-delay="0s">
              <p className="text-center"><span className="emphasize-text-solution">Start doing <u>ministry.</u></span></p>
            </div>
            <br />
            <br />
            <div className="wow fadeIn" data-wow-duration="2s" data-wow-delay="1s">
              <div className="cta-button scroll-to-section text-center">
                <a href="/sign-in" className="bg-blue-500 text-white py-2 px-4 rounded-full">Start Today</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTA;